import { useEffect, useRef } from "react";

const REVEAL_THRESHOLD = 0.12;

export function useReveal() {
  const ref = useRef(null);
  useEffect(() => {
    const els = ref.current?.querySelectorAll("[data-reveal]") || [];
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("mp-fade");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: REVEAL_THRESHOLD }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
  return ref;
}
